import React, { useState } from 'react'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { FEEDBACK_DEFAULTS, MODULE_KEYS } from '../../moduleRegistry'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { Heading } from '../HeadingModule/Heading'
import { Subheading } from '../HeadingModule/Subheading'
import { StarRating } from './StarRating'
import '../../styles/ExpandedFeedbackModule/FeedbackInternal.scss'

type Props = {
  onSubmitted: () => void
}

/** Feedback state: star rating plus an optional comment and submit. */
export const FeedbackInternal = ({ onSubmitted }: Props) => {
  const { internalHeading, internalSubheading, completedCTA } = useModuleConfig(
    MODULE_KEYS.feedback,
    FEEDBACK_DEFAULTS
  )
  const { state: { pageKey } } = useMatchScreen()
  const [rating, setRating] = useState<number | null>(null)
  const [comment, setComment] = useState('')

  const handleRatingChange = (value: number) => {
    setRating(value)
    trackEvent('FeedbackModule', 'CSAT Vote', {
      page_key: pageKey,
      vote: value,
      question: internalHeading
    })
  }

  const handleSubmit = () => {
    trackEvent('FeedbackModule', 'CSAT Comment', {
      page_key: pageKey,
      comment,
      question: internalHeading
    })
    onSubmitted()
  }

  return (
    <div className="expanded-feedback-module__internal" data-testid="expanded-feedback-internal">
      <Heading as="h2" id="expanded-feedback-heading" className="expanded-feedback-module__heading" text={internalHeading} />
      <StarRating value={rating} onChange={handleRatingChange} />
      <Subheading id="expanded-feedback-comment-label" className="expanded-feedback-module__subheading" text={internalSubheading} />
      <div className="expanded-feedback-module__comment">
        <textarea
          id="expanded-feedback-comment"
          name="expanded-feedback-comment"
          aria-labelledby="expanded-feedback-comment-label"
          className="expanded-feedback-module__textarea"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          maxLength={150}
        />
        <button
          type="button"
          className="expanded-feedback-module__button expanded-feedback-module__button-submit"
          onClick={handleSubmit}
        >
          {completedCTA}
        </button>
      </div>
    </div>
  )
}
